import styled from 'styled-components'
// themes
import colors from 'themes/colors'

export const Description = styled.p`
  font-size: 14px;
  color: ${colors.gray400};
  margin-bottom: 8px;
`

export const ButtonsContainer = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`

export const PromptsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`

export const PromptChip = styled.button`
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  color: ${colors.gray380};
  background: white;
  border: 1px solid ${colors.gray280};
  border-radius: 12px;
  padding: 6px 12px;
  font-size: 13px;
  line-height: 1.4;
  cursor: pointer;
  font-family: inherit;
  text-align: start;
  max-width: 100%;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${colors.purple100};
  }
`
